import React, { useEffect, useRef, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import ErrorBoundary from '../ErrorBoundary';
import BrandedPageLoader from '../BrandedPageLoader';
import './Layout.css';

/**
 * Routed content only. The persistent sidebar/topbar are mounted once in App
 * through AdminChrome and therefore never disappear while switching pages.
 */
const Layout = () => {
  const location = useLocation();
  const firstRender = useRef(true);
  const [routePulse, setRoutePulse] = useState(false);

  useEffect(() => {
    const frame = window.requestAnimationFrame(() => window.scrollTo({ top: 0, behavior: 'auto' }));

    // Do not blank/fade the page. Show only a tiny non-blocking branded pulse
    // after an internal route change so navigation feels responsive.
    let timer;
    if (firstRender.current) {
      firstRender.current = false;
    } else {
      setRoutePulse(true);
      timer = window.setTimeout(() => setRoutePulse(false), 520);
    }

    return () => {
      window.cancelAnimationFrame(frame);
      if (timer) window.clearTimeout(timer);
    };
  }, [location.pathname, location.search]);

  const routeKey = `${location.pathname}${location.search}`;

  return (
    <main className="tf-admin-main">
      <div className="tf-admin-route-stage">
        {routePulse && (
          <div className="tf-admin-route-pulse" aria-live="polite" aria-label="Loading page">
            <BrandedPageLoader micro />
          </div>
        )}
        <div className="tf-admin-route-content">
          <ErrorBoundary resetKey={routeKey}>
            <Outlet />
          </ErrorBoundary>
        </div>
      </div>
    </main>
  );
};

export default Layout;